import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();

  let icon = cygnusSpriteHtml('check-circle', { variant: 'solid', className: 'text-success' })
  let text = 'None';

  if (value === 'N') {
    icon = cygnusSpriteHtml('x-circle', { variant: 'solid', className: 'text-danger' })
  } else if (value === 'S') {
    text = 'Sale';
  } else if (value === 'H') {
    text = 'Hire';
  }

  const el = document.createElement('div');
  el.classList.add('d-flex', 'flex-column', 'align-items-center');

  el.innerHTML = `<div>${icon}</div><div>${text}</div>`;

  return el;
}
